import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as Privado } from "../../assets/svg/botoneraPrivado.svg";
import { ReactComponent as Publico } from "../../assets/svg/botoneraPublico.svg";
import { ReactComponent as Persona } from "../../assets/svg/botoneraPersona.svg";
import { ReactComponent as Personas } from "../../assets/svg/botoneraPersonas.svg";
import { ReactComponent as Maquina } from "../../assets/svg/botoneraMaquina.svg";
import { ReactComponent as Producto } from "../../assets/svg/botoneraProducto.svg";
import { ReactComponent as Obras } from "../../assets/svg/misProyectosLittle.svg";
import { ReactComponent as Notificaciones } from "../../assets/svg/nav-notif-active.svg";
import styles from "./Botonera.module.scss";
import Boton from "./Boton";
import { useDispatch, useSelector } from "react-redux";
import { BackgroundOverlay, OnBoardingList, OnBoardingModal, RelativeContainer } from "../Dashboard/OnBoarding/OnBoarding";
import { closeOnBoardingModal, nextOnBoardingModal, previousOnBoardingModal } from "../../store/actions";

const Botonera = ({mobileStylesFromParent}) => {

  const OnBoardingIndex = useSelector((state) => state.dashboard.currentOnBoardingModal)
  const [ocultarEnMobile, setOcultarEnMobile] = useState(false);
  const [isSelected, setIsSelected] = useState({ name: "", isSelected: false });
  const [mobileStyles, setMobileStyles] = useState(false);
  const dispatch = useDispatch()
  const history = useHistory();

  const handleResize = () => {
    const windowWidth = window.innerWidth;
    setOcultarEnMobile(windowWidth < 768);
    setMobileStyles(windowWidth < 768);
  };

  // Ejecutar handleResize al cargar el componente
  useEffect(() => {
    handleResize();
  }, []);

  // Agregar un event listener para el cambio de tamaño de la ventana
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    // Limpiar el event listener al desmontar el componente
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Da un estilo condicional al boton cuando se esta en una seccion
  useEffect(() => {
    if (window.location.pathname === "/dashboard") {
      setIsSelected({ name: "Muro Edify", isSelected: true });
    } else if (window.location.pathname === "/proyectosprivados") {
      setIsSelected({ name: "Obras Privadas", isSelected: true });
    } else if (window.location.pathname === "/licitacionespublicas") {
      setIsSelected({ name: "Obras Públicas", isSelected: true });
    } else if (window.location.pathname === "/cotizaciondemateriales") {
      setIsSelected({ name: "Materiales", isSelected: true });
    } else if (window.location.pathname === "/solicitudes") {
      setIsSelected({ name: "Notificaciones", isSelected: true });
    }
  }, []);

  const botones = [
    {
      nombre: "Muro Edify",
      icono: <Privado />,
      background: "#7000ff",
      isSelected: isSelected,
      ocultarEnMobile: false,
      mobileStyles: mobileStyles || mobileStylesFromParent,
      onClick: () => {
        history.push("/dashboard");
      },
    },
    {
      nombre: "Obras Privadas",
      icono: <Obras />,
      background: "#234BA2",
      isSelected: isSelected,
      ocultarEnMobile: false,
      mobileStyles: mobileStyles || mobileStylesFromParent,
      onClick: () => {
        history.push("/proyectosprivados");
      },
    },
    {
      nombre: "Obras Públicas",
      icono: <Publico />,
      background: "#f5b048",
      isSelected: isSelected,
      ocultarEnMobile: false,
      mobileStyles: mobileStyles || mobileStylesFromParent,
      onClick: () => {
        history.push("licitacionespublicas");
      },
    },
    {
      nombre: "Materiales",
      icono: <Producto />,
      background: "#45a7ff",
      isSelected: isSelected,
      ocultarEnMobile: false,
      mobileStyles: mobileStyles || mobileStylesFromParent,
      onClick: () => {
        history.push("/cotizaciondemateriales");
      },
    },
    {
      nombre: "Notificaciones",
      icono: <Notificaciones />,
      background: "#D05004",
      isSelected: isSelected,
      ocultarEnMobile: false,
      mobileStyles: mobileStyles || mobileStylesFromParent,
      onClick: () => {
        history.push("/solicitudes");
      },
    }
   /* {
      nombre: "Comunidad Edify",
      icono: <Personas />,
      background: "#eeeeee",
      image: ComunidadEdify,
      ocultarEnMobile: false,
      mobileStyles: mobileStyles || mobileStylesFromParent,
      onClick: () => {
        history.push("/comunidad-edify");
      },
    }, 
    {
      nombre: "Seguros",
      icono: <Persona />,
      background: "#D05004",
      image: Seguros,
      ocultarEnMobile: ocultarEnMobile || mobileStylesFromParent,
      mobileStyles: false,
      onClick: () => {
        history.push("/segurosparatrabajadoresyequipos");
      },
    },
    {
      nombre: "Alquiler de Maquinarias",
      icono: <Maquina />,
      background: "#22af86",
      image: Maquinarias,
      ocultarEnMobile: ocultarEnMobile || mobileStylesFromParent,
      mobileStyles: false,
      onClick: () => {
        history.push("/alquilerdemaquinarias");
      },
    },
     */
  ];


  return (
    <div className={styles.container}>
      {botones.map((boton, index) => (
        boton?.ocultarEnMobile === true ? null : (
        <div key={boton.nombre} className={`${styles.relativeContainer} ${isSelected.name === boton.nombre ? styles.isSelected : ""}`} >
          <Boton {...boton} isCurrentOnBoardingModal={OnBoardingIndex === (index + 1)} />
          {
            OnBoardingIndex === (index + 1) && (
              <>
                <BackgroundOverlay />
                <OnBoardingModal isFirst={false} onSkip={() => dispatch(closeOnBoardingModal())} top={120} onClickNext={() => dispatch(nextOnBoardingModal())} isLast={(index + 2) === OnBoardingList.length} onClickPrevious={() => dispatch(previousOnBoardingModal())}>
                  {OnBoardingList[OnBoardingIndex].description}
                </OnBoardingModal>
              </>
            )
          }
        </div>
        )
      ))}
    </div>
  );
};

export default Botonera;
